import React, { useState } from 'react';
import {
  Wrap,
  StyledSlider,
  SliderItem,
  PageView,
  Buttons,
  ReportButton,
  DeleteButton
} from './styled';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { Url } from '../../../../../common/constants/environment';
import useTypeStore from '../../../../../hooks/useTypeStore';
import useModalStore from '../../../../../hooks/useModalStore';
import useUsersStore from '../../../../../hooks/useUsersStore';
import { observer } from 'mobx-react';

const SuperChatCarousel = observer(
  ({
    powerChat,
    viewChat,
    setViewChat,
    changeCurrentSlide,
    bottomSheetToggle,
    setBottomSheetPhrases,
    deletePowerChat
  }) => {
    const modalStore = useModalStore();
    const communityStore = useTypeStore('communityStore');
    const usersStore = useUsersStore();
    const [currentSlide, setCurrentSlide] = useState(1);

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      beforeChange: (oldIndex, newIndex) => {
        setCurrentSlide(newIndex + 1);
        changeCurrentSlide(newIndex);
      }
    };

    const onClickReport = (chat) => {
      modalStore.openConfirmModal({
        message: `신고를 접수하시겠습니까?`,
        okCallback: () => {
          const params = {
            category: 'cheer',
            relId: chat.id,
            relTable: '@cheer',
            targetId: chat.user_id
          };
          communityStore.actionReport(params);
        }
      });
    };

    const onClickDelete = (chat, index) => {
      modalStore.openConfirmModal({
        message: `삭제 하시겠습니까?`,
        okCallback: () => {
          deletePowerChat(chat, index);
        }
      });
    };

    return (
      <Wrap view={viewChat} onClick={() => setViewChat(false)}>
        <StyledSlider {...settings}>
          {powerChat.comments.map((item, key) => {
            return (
              <div key={key}>
                <ChatItem
                  item={item}
                  currentSlide={currentSlide}
                  totalCount={powerChat.totalCount}
                  setViewChat={setViewChat}
                  viewChat={viewChat}
                  bottomSheetToggle={bottomSheetToggle}
                  setBottomSheetPhrases={setBottomSheetPhrases}
                />
                {viewChat && (
                  <Buttons>
                    <ReportButton
                      onClick={(e) => {
                        e.stopPropagation();
                        onClickReport(item);
                      }}
                    >
                      신고하기
                    </ReportButton>
                    {usersStore.data.mb_id === item.user_id && (
                      <DeleteButton
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickDelete(item, key);
                        }}
                      >
                        삭제하기
                      </DeleteButton>
                    )}
                  </Buttons>
                )}
              </div>
            );
          })}
        </StyledSlider>
      </Wrap>
    );
  }
);

const ChatItem = ({
  item,
  currentSlide,
  totalCount,
  setViewChat,
  viewChat,
  bottomSheetToggle,
  setBottomSheetPhrases
}) => {
  const onClickCopy = (event) => {
    event.stopPropagation();
    event.currentTarget.select();
    document.execCommand('Copy');
    setBottomSheetPhrases('클립보드에 복사되었습니다');
    bottomSheetToggle();
  };

  const contentFormat = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, key) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={key}
            href={part}
            target="_blank"
            onClick={(e) => e.stopPropagation()}
            className={'power-chat-link'}
          >
            {part}
          </a>
        );
      }

      if (part.match(/\[[A-Za-z0-9]+\]/g)) {
        return part.split(/(\[[A-Za-z0-9]+\])/g).map((subPart, key) => {
          if (subPart.includes('[')) {
            return (
              <label key={key} className={'power-chat-copy'}>
                {subPart.substr(1, subPart.length - 2)}
                <input
                  type={'text'}
                  readOnly={true}
                  onClick={onClickCopy}
                  value={subPart.substr(1, subPart.length - 2)}
                />
              </label>
            );
          }
          return subPart;
        });
      }

      return part;
    });
  };

  return (
    <SliderItem
      view={viewChat}
      onClick={(e) => {
        e.stopPropagation();
        setViewChat(true);
      }}
      className={clsx(!viewChat && 'power-chat-item')}
    >
      <PageView>{`${currentSlide} / ${totalCount}`}</PageView>
      <Link
        className={'profile_img'}
        to={`/user/${item.user_id}`}
        onClick={(e) => e.stopPropagation()}
      >
        <span className={clsx('thumb', `lv${item.level}`)}>
          <img
            src={
              item.profile_image_path
                ? `${
                    Url.thumb
                  }normal/crop/112x112${item.profile_image_path.replace(
                    'data/',
                    ''
                  )}`
                : '/images/thumb_user_def.png'
            }
            onError={(event) => {
              event.target.src = '/images/thumb_user_def.png';
            }}
          />
          <svg
            className="border"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 36 36"
            enableBackground="new 0 0 36 36"
            xmlSpace="preserve"
          >
            <path d="M18,2c10.9,0,16,5.1,16,16c0,10.9-5.1,16-16,16C7.1,34,2,28.9,2,18C2,7.1,7.1,2,18,2 M18,0C6,0,0,6,0,18c0,12,6,18,18,18c12,0,18-6,18-18C36,6,30,0,18,0L18,0z" />
          </svg>
        </span>
      </Link>
      <div>
        <span className={'nick'}>{item.mb_nick}</span>
        <div className={clsx('message', viewChat && 'open')}>
          {contentFormat(item.content)}
        </div>
      </div>
    </SliderItem>
  );
};

export default SuperChatCarousel;
